module.exports = __webpack_public_path__ + "img/img-service.9cb70abe.png";